import { QuickJournalOverlay } from "./QuickJournalOverlay";
import * as classNames from "classnames";
import * as React from "react";
import Render from "../../Shared/Render";
import * as styles from "../BottomBar.css";
import { ThemeSwitcherContainer } from "./BottomBarSubComponents";
import { BottomBarControls } from "./Controls/BottomBarControls";
import {
    ShouldShowQuickJournalDemoStats,
    IsIosDevice,
} from "../Services/BottomBarHelpers";
import { calcTarget_BottomBar } from "../Services/BottomBarStyles";
import { QuickJournalStreakHeatmap } from "../QuickJournal/View/Heatmap/QuickJournalStreakHeatmap";
import { GetQuickJournalTheme } from "../QuickJournal/View/QuickJournalTheme";
import { BuildQuickJournalDemoStats } from "../QuickJournal/Data/Stats/QuickJournalStatsDemo";
import { BuildQuickJournalStats } from "../QuickJournal/Data/Stats/QuickJournalStatsBuild";
import { IBottomBarRenderProps } from "./IBottomBarRenderProps";

export function BottomBarRender({
    state,
    quickJournalHasFocus,
    isClosingQuickJournal,
    bottomInset,
    onThemeNameChange,
    onKeyboardFocusChange,
    onEntrySubmitted,
    onRecentEntriesChange,
    onCloseQuickJournal,
}: IBottomBarRenderProps) {
    const quickJournalStats = ShouldShowQuickJournalDemoStats()
        ? BuildQuickJournalDemoStats()
        : BuildQuickJournalStats(
              state.quickJournalRecentEntries,
              state.quickJournalWeeklyHourlyCounts,
          );
    const shouldHideLowerControls =
        state.showQuickJournal &&
        (quickJournalHasFocus || isClosingQuickJournal) &&
        IsIosDevice();
    const shouldShowQuickJournal =
        state.showQuickJournal || isClosingQuickJournal;
    const shouldApplyIosBottomInset =
        IsIosDevice() && bottomInset >= 60 && quickJournalHasFocus;
    const bottomOffset = shouldApplyIosBottomInset ? bottomInset : 0;
    const quickJournalTheme = GetQuickJournalTheme(state.quickJournalThemeName);

    return (
        <>
            <ThemeSwitcherContainer
                visible={shouldShowQuickJournal}
                activeThemeName={state.quickJournalThemeName}
                onThemeNameChange={onThemeNameChange}
            />
            <Render id="quickJournalStreakHeatmap" when={shouldShowQuickJournal}>
                <div
                    style={{
                        position: "fixed",
                        top: "calc(env(safe-area-inset-top, 0px) + 14px)",
                        left: 0,
                        right: 0,
                        display: "flex",
                        justifyContent: "center",
                        pointerEvents: "none",
                        zIndex: 20001,
                    }}
                >
                    <QuickJournalStreakHeatmap
                        stats={quickJournalStats}
                        flashCellKey={state.quickJournalHeatmapFlashCellKey}
                        flashStartedAt={state.quickJournalHeatmapFlashStartedAt}
                        theme={quickJournalTheme}
                    />
                </div>
            </Render>
            <div
                id={calcTarget_BottomBar}
                className={classNames(styles.container, {
                    [styles.displaySmall]: true,
                    [styles.container_ifHighPerformance]: !IsIosDevice(),
                    [styles.ifDesktop_Transition]: !IsIosDevice(),
                })}
                style={{
                    position: `fixed`,
                    bottom: `${bottomOffset}px`,
                    left: 0,
                }}
            >
                <div className={styles.controlsBackdrop} />
                <div className={styles.verticalCenter}>
                    <BottomBarControls
                        isQuickJournalVisible={shouldShowQuickJournal}
                        displayLarge={state.showQuickJournal}
                    />
                </div>
            </div>
            <Render id="displayLargeItems" when={shouldShowQuickJournal}>
                <QuickJournalOverlay {...{ state, quickJournalHasFocus, isClosingQuickJournal, bottomInset,
                    onThemeNameChange, onKeyboardFocusChange, onEntrySubmitted, onRecentEntriesChange,
                    onCloseQuickJournal, shouldHideLowerControls }} />
            </Render>
        </>
    );
}
